import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import InnerLayout from '../components/InnerLayout';

export default function Privacidad() {
  useEffect(() => { document.title = 'Privacidad de Datos — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Política de" titleAccent="Privacidad" subtitle="Cómo recopilamos, usamos y protegemos tus datos personales." breadcrumb="Privacidad">
      <div className="legal-updated">Última actualización: Enero 2026</div>
      <div className="legal-content">
        <p>En Sttora nos comprometemos a proteger tu privacidad. Esta política describe cómo recopilamos, utilizamos y protegemos la información personal que nos proporcionas.</p>
        <h2>Datos que Recopilamos</h2>
        <ul>
          <li>Información de registro: nombre, correo electrónico, contraseña cifrada</li>
          <li>Información de perfil: dirección, teléfono, preferencias de contacto</li>
          <li>Datos de transacciones: historial de pedidos, métodos de pago (no almacenamos datos completos de tarjetas)</li>
          <li>Datos de uso: interacciones con la plataforma, preferencias, dispositivos utilizados</li>
        </ul>
        <h2>Cómo Usamos tus Datos</h2>
        <ul>
          <li>Procesar y gestionar pedidos y servicios</li>
          <li>Mejorar la experiencia de usuario en la plataforma</li>
          <li>Enviar comunicaciones relevantes, si has dado tu consentimiento</li>
          <li>Cumplir con obligaciones legales y fiscales</li>
        </ul>
        <h2>Compartición de Datos</h2>
        <p>No vendemos tus datos personales. Podemos compartirlos con proveedores de servicios estrictamente necesarios bajo acuerdos de confidencialidad, y con autoridades cuando la ley lo exija.</p>
        <h2>Tus Derechos</h2>
        <p>Tienes derecho a acceder, rectificar, cancelar u oponerte al tratamiento de tus datos (ARCO). Para ejercerlos: <a href="mailto:privacidad@sttora.com">privacidad@sttora.com</a></p>
        <h2>Seguridad</h2>
        <p>Implementamos medidas técnicas y organizativas para proteger tus datos contra acceso no autorizado, pérdida o alteración.</p>
        <h2>Cookies</h2>
        <p>Para información sobre el uso de cookies, consulta nuestra <Link to="/legal/cookies">Política de Cookies</Link>.</p>
        <h2>Cambios en esta Política</h2>
        <p>Podemos actualizar esta política periódicamente. Te notificaremos sobre cambios significativos a través de la plataforma o por correo electrónico.</p>
      </div>
    </InnerLayout>
  );
}
